import { ENGLISH_LANG_CODE } from "@evennt-tech/api-v2-core";

export const resolveActiveLanguage = ({
  preferred,
  availableCodes,
  effectiveCodes,
  adminDisabledCodes,
  showDefaultLanguage,
}: {
  preferred?: string;
  availableCodes: string[];
  effectiveCodes?: string[];
  adminDisabledCodes?: string[];
  showDefaultLanguage?: string;
}): string => {
  const isRenderable = (code?: string): code is string =>
    !!code && availableCodes.includes(code);

  if (
    isRenderable(preferred) &&
    (!effectiveCodes || effectiveCodes.includes(preferred))
  ) {
    return preferred;
  }

  // Inside a show, a language the Admin switched off (its grant disabled, or
  // the language unpublished) renders English (UK) and skips the show default
  // (FS-2999 §4, AC 43–44). A language the organiser disabled falls through to
  // the default.
  if (
    effectiveCodes &&
    preferred &&
    preferred !== ENGLISH_LANG_CODE &&
    (adminDisabledCodes?.includes(preferred) || !isRenderable(preferred))
  ) {
    return ENGLISH_LANG_CODE;
  }

  if (isRenderable(showDefaultLanguage)) {
    return showDefaultLanguage;
  }

  return ENGLISH_LANG_CODE;
};
